import { createSlice } from '@reduxjs/toolkit';

import { CarsState } from '../../types';

import { CARS_STATE } from '../../constants';

import { setEBoxLocations } from './setEBoxLocations';
import { resetEBoxLocations } from './resetEBoxLocations';

import { setSelectedEBoxLocation } from './setSelectedEBoxLocation';
import { setEBoxDashboardData } from './setEBoxDashboardData';
import { resetEBoxDashboardData } from './resetEBoxDashboardData';
import { updateEBoxDashboardData } from './updateEBoxDashboardData';
import { setT4EboxDevices } from './setT4EboxDevices';

const initialState: CarsState = {
  eBoxLocations: {},
  eBoxDashboardData: {},
  t4EboxDevices: {},
};

export const carsSlice = createSlice({
  name: CARS_STATE,
  initialState,
  reducers: {
    resetEBoxLocations,
    resetEBoxDashboardData,

    setSelectedEBoxLocation,
    updateEBoxDashboardData
  },
  extraReducers: (builder) => {
    setEBoxLocations(builder);
    setEBoxDashboardData(builder);
    setT4EboxDevices(builder);
  },
});

export const carsActions = carsSlice.actions;
export const carsReducer = carsSlice.reducer;
